import { create } from "zustand";

import { useAvailableServicesStore } from "./availableServicesStore";
import { useProvidedServicesStore } from "./providedServicesStore";

const initialState = {
  selectedAvailableServices: [],
  selectedProvidedServices: [],
  servicesToBeAdded: [],
  servicesToBeRemoved: [],
  disableSaveBtn: true,
  disableCancelBtn: true,
};

export const useServicesStore = create((set) => ({
  ...initialState,

  setSelectedAvailableServices: (selectedAvailableServices) => set({ selectedAvailableServices }),
  setSelectedProvidedServices: (selectedProvidedServices) => set({ selectedProvidedServices }),
  setServicesToBeAdded: (servicesToBeAdded) => set({ servicesToBeAdded }),
  setServicesToBeRemoved: (servicesToBeRemoved) => set({ servicesToBeRemoved }),
  setDisableSaveBtn: (value) => set({ disableSaveBtn: value }),
  setDisableCancelBtn: (value) => set({ disableCancelBtn: value }),

  reset: () => set(initialState),

  resetAll: async () => {
    set(initialState);

    const providedStore = useProvidedServicesStore.getState();
    providedStore.reset();

    const availableStore = useAvailableServicesStore.getState();
    availableStore.reset();
  },
}));
